import React from 'react';
import {FormattedMessage} from "react-intl";
import qrImg from "../assets/img/qr.png";

function ScanQrToContinue() {
    return (
        <div className="scan-qr-msg" data-qa="scan-qr-msg">
            <div className="row">
                <img className="qr-img" src={qrImg}/>
                <FormattedMessage id="ScanTheQrToContinue"/>
            </div>
        </div>
    );
}

export default ScanQrToContinue;
